import { library } from "@fortawesome/fontawesome-svg-core";

import { 
  faChartLine,
  faMoneyBill,
  faEnvelope,
  faTachometerAlt,
  faTrashCan,
  faBook,
  faBoxes,
  faBox,
  faUsers,
  faShoppingCart,
  faDollarSign,
  faCog,
  faUser,
  faSignOutAlt,
  faSearch,
  faBell,
  faPlus,
  faArrowUp,
  faArrowDown,
  faPenToSquare,
  faPhone,
 faMapMarkerAlt,
 faCashRegister,
 faCreditCard,
 faIdBadge,
 faEye,
 faEdit,
 faUserAltSlash,
 faUserClock,
 faUserCheck

} from "@fortawesome/free-solid-svg-icons";

import {
  faFacebook,
  faTwitter,
  faInstagram,
  faLinkedin,
  faGithub,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

import {
   
  
    faCalendar
   } from "@fortawesome/free-regular-svg-icons";

library.add(
  //solid icons
  faIdBadge,
  faChartLine,
  faMoneyBill,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faBook,
  faTrashCan,
  faTachometerAlt,
  faBoxes,
  faUsers,
  faShoppingCart,
  faCog,
  faUser,
  faSignOutAlt,
  faSearch,
  faBell,
  faPlus,
  faArrowUp,
  faArrowDown,
  faPenToSquare,
  faDollarSign,
  faBox,
  faCashRegister,
  faCreditCard,
  faEye,
  faEdit,
  faUserAltSlash,
  faUserClock,
  faUserCheck,


  //brand icons
  faFacebook,
  faTwitter,
  faInstagram,
  faLinkedin,
  faGithub,
  faYoutube,

  //regular icons
  
  faCalendar
);
